"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const initVideoSlider = () => {
    const videoSliders = $('.video-carousel__slider');
    videoSliders.each(function () {
        const videoSlider = $(this);
        videoSlider.on('init', function (event, slick) {
            const currentS = $(slick.$slides[slick.currentSlide]);
            const prev = currentS.prev();
            const next = currentS.next();
            prev.addClass('slick-prev');
            next.addClass('slick-next');
            currentS.removeClass('slick-next slick-prev');
            slick.$prev = prev;
            slick.$next = next;
        });
        videoSlider.length <= 3 ? addSlides(videoSlider) : '';
        const options = {
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            speed: 300,
            variableWidth: true,
            centerMode: true,
            centerPadding: '0',
            customPaging: function (slider, i) {
                return '';
            },
            autoplaySpeed: 5000,
            slidesPerRow: 1,
            draggable: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoplay: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        mobileFirst: true,
                        swipeToSlide: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        adaptiveHeight: false,
                        swipeToSlide: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        swipeToSlide: true,
                        dots: false,
                    }
                }
            ]
        };
        videoSlider.slick(options);
        videoSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            const currentS = $(slick.$slides[nextSlide]);
            const prev = currentS.prev();
            const next = currentS.next();
            slick.$prev && slick.$prev.removeClass('slick-prev');
            slick.$next && slick.$next.removeClass('slick-next');
            prev.addClass('slick-prev');
            next.addClass('slick-next');
            slick.$prev = prev;
            slick.$next = next;
        });
        videoSlider.on('touchend touchcancel touchmove', () => {
            videoSlider.slick('slickPlay');
        });
        $('.video-carousel__arrows .arrow-prev').click(() => {
            videoSlider.slick('slickPrev');
        });
        $('.video-carousel__arrows .arrow-next').click(() => {
            videoSlider.slick('slickNext');
        });
    });
};
const addSlides = (videoSlider) => {
    if (videoSlider.children().length === 2) {
        videoSlider.append(videoSlider.children().eq(0).clone());
        videoSlider.append(videoSlider.children().eq(1).clone());
    }
    else if (videoSlider.children().length === 1) {
        const slidesToDuplicate = 3 - videoSlider.children().length;
        for (let i = 0; i < slidesToDuplicate; i++) {
            videoSlider.append(videoSlider.children().eq(i).clone());
        }
    }
};
$(document).ready(() => {
    initVideoSlider();
});
